/** The root organization: where a platform admin lands before picking another. */
export const ROOT_TENANT = 'cubicup';

export interface OrganizationOption {
  slug: string;
  name: string;
}

export interface ActiveOrganization {
  slug: string;
  /** What to call it in the UI: its name, or its slug if the list does not have it. */
  name: string;
}

/**
 * The organization the screens operate on. A platform admin works on the one
 * they picked in the header, else the root one. Anyone else works on THEIR
 * organization — the same first-by-slug rule the backends use to resolve it.
 * (Defaulting everyone to the root organization would put an admin of another
 * one on a tenant they cannot manage.)
 */
export function resolveActiveOrganization(user: {
  activeTenant: string | null;
  isSuperadmin: boolean;
  tenants: OrganizationOption[];
}): ActiveOrganization {
  const slug =
    user.activeTenant ?? (user.isSuperadmin ? ROOT_TENANT : user.tenants[0]?.slug ?? ROOT_TENANT);
  return { slug, name: user.tenants.find((tenant) => tenant.slug === slug)?.name ?? slug };
}
